import { render, staticRenderFns } from "./DataReportResult.vue?vue&type=template&id=f8d8a6be&scoped=true"
import script from "./DataReportResult.vue?vue&type=script&lang=js"
export * from "./DataReportResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d8a6be",
  null
  
)

export default component.exports